import { apiClient } from './client';

export interface ReliableSymptomItem {
  value: string;
  label: string;
  category?: string;
}

export interface ReliableSymptomsResponse {
  items: ReliableSymptomItem[];
}

export const getReliableSymptoms = async (): Promise<{ items: ReliableSymptomItem[] }> => {
  // Endpoint ubicado en /patients/symptoms/reliable
  const response = await apiClient.get('/patients/symptoms/reliable');
  return response.data;
};

export interface DeletePatientSymptomPayload {
  email: string;
  name: string;
  date_0: string;
  consultation_token?: string;
  symptom_description: string;
}

export const deletePatientSymptom = async (payload: DeletePatientSymptomPayload): Promise<{ message: string; deleted: number }> => {
  const response = await apiClient.delete('/patients/symptoms', { data: payload });
  return response.data;
};
